import { GetUseReasonDto } from '../../../../../dataAccess/webApi/dto/useReasonDto';
import { GetFacilityDto } from '../../../../../dataAccess/webApi/dto/facilitiesDto';
import { NullPropsToUndefinedType } from '../../../../../utils/typeUtil';
import { translate } from '../../../../../i18n'
import { AttentionLabel } from '../../attentionLabel'
import { UseReasonRadioGroup, UseReasonOptions } from '../../../facilityReservationForm/useReasonRadioGroup'
import { Stack } from '@mui/material';
import { UseFormSetValue } from 'react-hook-form';

// 利用目的
const UseReasonSelection = (props: {
  useReason: GetUseReasonDto,
  useReasonOptions: UseReasonOptions
  facility: NullPropsToUndefinedType<GetFacilityDto>,
  purposeOfUse: string
  useReasonDetailIrregular: string
  useReasonDetailEmg: string
  useReasonDetailRefresh: string
  isDetailHidden?: boolean
  onChange: (newPurpose: string) => void
  setValue: UseFormSetValue<any>
}) => (
  <Stack>
    <div>
      {translate('facilityLotteryReservationUpdateSelection.label.useReason')}
      <AttentionLabel>*</AttentionLabel>
    </div>
    <UseReasonRadioGroup
      useReason={props.useReason}
      useReasonOptions={props.useReasonOptions}
      facility={props.facility}
      purposeOfUse={props.purposeOfUse}
      useReasonDetailIrregular={props.useReasonDetailIrregular}
      useReasonDetailEmg={props.useReasonDetailEmg}
      useReasonDetailRefresh={props.useReasonDetailRefresh}
      onChange={props.onChange}
      isDetailHidden={props.isDetailHidden}
      setValue={props.setValue}
    />
  </Stack>
);
export default UseReasonSelection;